import cn from 'classnames';

import LandingPageImage from 'components/landing/LandingPageImage';
import LandingPageLink from 'components/landing/LandingPageLink';
import css from 'styles/components/landing/twoWideBlocks.scss';

const TwoWideBlocks = ({ slotName, slotIndex, slotDetails, onLandingComponentClick }) => {
  const { heading, nobottommargin, block, monetateId } = slotDetails;
  return (
    <div className={cn(css.container, { [css.noBotMargin]: nobottommargin === 'true' })} data-slot-id={slotName} data-monetate-id={monetateId}>
      {heading && <h2>{heading}</h2>}
      {block.map(v => {
        const { link, bgsrc, src, retina, mobilesrc, mobileretina, tabletsrc, tabletretina, alt, heading, subheading, cta, gae, type, bgsize, bgposition, width } = v;

        let style = bgsrc ? { backgroundImage: `url(${bgsrc})` } : {};
        style = bgposition ? { ...style, backgroundPosition: bgposition } : style;
        style = bgsize ? { ...style, backgroundSize: bgsize } : style;
        style = width ? { ...style, width } : style;

        const key = bgsrc || src || heading || gae;
        const imageProps = { src, retina, mobilesrc, mobileretina, tabletsrc, tabletretina, alt, shouldLazyLoad: true };
        const contents = (
          <>
            <LandingPageImage {...imageProps} />
            {heading && <h3>{heading}</h3>}
            {subheading && <p className={css.subheading}>{subheading}</p>}
            {cta && <p className={css.cta}>{cta}</p>}
          </>
        );

        const linkProps = {
          'onClick': onLandingComponentClick,
          'data-eventlabel': 'twoWideBlocks',
          'data-slotindex': slotIndex,
          'data-eventvalue': gae || heading || alt,
          'className': cn(css.block, { [css.light]: type === 'light' }),
          style,
          key
        };
        return (
          <LandingPageLink
            key={key}
            url={link}
            fallbackNode="div"
            {...linkProps}
          >
            {contents}
          </LandingPageLink>
        );
      })}
    </div>
  );
};

export default TwoWideBlocks;
